import React from 'react'
import style from './Subproducts.module.scss'
import { IEcommerceAnswerSchema, IEcommerceQuestionSchema } from '../../types'
import { useFamilyAxes } from '../../hooks/useFamilyAxes'
import { LEGACY_AXIS } from '../../utils/familyAxes'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'

interface ISubproductsProps {
  answer: IEcommerceAnswerSchema
  schema: IEcommerceQuestionSchema
  onSubitemSelect: (index: number) => void
}

// AYTM-12710: multi-axis selector for Standard. Per spec §Variant Selector §Interactions,
// Standard's row label does not respond to hover.
const Subproducts = ({ answer, schema, onSubitemSelect }: ISubproductsProps) => {
  const viewport = useViewport()
  const { childrenProducts, axes, currentSelections, findSKUForValue, isCompatibleWithUpperAxes } = useFamilyAxes({
    answer,
    schema
  })

  if (childrenProducts.length <= 1 || axes.length === 0) return null

  function selectValue(axisName: string, value: string) {
    const targetSKU = findSKUForValue(axisName, value)
    if (!targetSKU) return
    const answerIndex = schema.answers.indexOf(targetSKU)
    if (answerIndex >= 0) onSubitemSelect(answerIndex)
  }

  return (
    <div className={`${style.subproducts} ${viewport.mobile ? style.subproductsMobile : ''}`}>
      {axes.map((axis, axisIndex) => {
        const selectedValue = currentSelections[axis.name] || ''
        return (
          <React.Fragment key={axis.name}>
            {axis.name !== LEGACY_AXIS && (
              <div className={style.title}>
                <strong>{axis.name}&nbsp;</strong>
                <span>{selectedValue}</span>
              </div>
            )}
            <div className={style.subproductsList}>
              {axis.values.map(value => {
                // Standard hides incompatible values entirely on lower axes; axis 1 always
                // renders every value. Spec §Multi-Axis Selector Pattern §Per-retailer divergence.
                if (!isCompatibleWithUpperAxes(axisIndex, value)) return null

                const isSelected = selectedValue === value
                return (
                  <button
                    key={value}
                    aria-pressed={isSelected}
                    onClick={() => selectValue(axis.name, value)}
                    className={`${style.subproduct} ${isSelected ? style.active : ''}`}
                  >
                    {value}
                  </button>
                )
              })}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Subproducts
